import { SafeUrl } from '@angular/platform-browser';
import { UserSource } from '@app/profile/enums/profile.enums';
import { Observable } from 'rxjs';

export const MyProfileRoute = 'me';

export const SkillLimit = 24;

export enum ProfileSection {
  DESCRIPTION = 'description',
  SKILLS = 'skills',
}

export const SkillStrength: { [key: string]: string } = {
  0: $localize`profile.skillStrength.informed`,
  1: $localize`profile.skillStrength.experienced `,
  2: $localize`profile.skillStrength.expert`,
};

export interface ProfileDetail {
  id?: number;
  externalId?: string;
  name?: string;
  jobTitle?: string;
  businessPhones?: string[];
  mobilePhone?: string;
  email?: string;
  officeLocation?: string;
  description?: string;
  skills?: SkillDetail[];
  avatar$?: Observable<SafeUrl>;
  department?: string;
  source?: UserSource;
  preferredLanguage?: string;
}

export interface SkillDetail {
  id: number;
  order?: number;
  name: string;
  level: number;
  externalId: string;
}

export type UpdateField = 'skills' | 'description' | 'preferredLanguage';
export interface ProfileUpdate {
  op?: 'replace';
  path: UpdateField;
  value: SkillDetail[] | string;
}

export interface EscoSkill {
  externalId: string;
  name: string;
}
